import { BaseContextService } from '../../base-context.service';
import { RoleResponseDto } from '../dto/response/role-response.dto';
import { RoleSaveRequestDto } from '../dto/request/role-save-request.dto';

class RoleService extends BaseContextService {
  public async fetchRoles(): Promise<RoleResponseDto[]> {
    const response = await this.get<RoleResponseDto[]>('/role');
    return response.data;
  }

  public async fetchRoleById(id: string): Promise<RoleResponseDto> {
    const response = await this.get<RoleResponseDto>(`/role/${id}`);
    return response.data;
  }

  public async createRole(Role: RoleSaveRequestDto): Promise<RoleResponseDto> {
    const response = await this.post<RoleResponseDto>(`/role`, Role);
    return response.data;
  }

  public async updateRole(
    id: string,
    Role: RoleSaveRequestDto
  ): Promise<RoleResponseDto> {
    const response = await this.put<RoleResponseDto>(`/role/${id}`, Role);
    return response.data;
  }

  public async deleteRole(id: string): Promise<void> {
    await this.delete<void>(`/role/${id}`);
  }
}

const Service = new RoleService();
export default Service;
